import { render } from "./CreateBAST.vue?vue&type=template&id=311d2a24&scoped=true"
import script from "./CreateBAST.vue?vue&type=script&lang=js"
export * from "./CreateBAST.vue?vue&type=script&lang=js"

import "./CreateBAST.vue?vue&type=style&index=0&id=311d2a24&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-311d2a24"]])

export default __exports__